import { useTranslation } from 'react-i18next'

import TarrifPop from 'entities/ticket/ui/tarrif-pop'

import { MyTicketItem } from 'shared/api/MyTicketsModel'
import { usePrivacyPolicyDocument } from 'shared/hooks'
import { TicketItem } from 'shared/models/ticket'
import { useDialogBottomSheet } from 'shared/ui/dialog-bottom-sheet/lib'

import s from './styles.module.scss'

interface Props {
  selectedTicket: TicketItem | MyTicketItem
}

export const ConfirmPayment = ({ selectedTicket }: Props) => {
  const { t } = useTranslation()
  const { openPrivacyPolicy } = usePrivacyPolicyDocument()

  const { openDialog } = useDialogBottomSheet()

  const showPublicOffer = () => {
    void openPrivacyPolicy('base_public_offer')
  }

  const showTicketTariff = () => {
    openDialog({
      child: <TarrifPop rulesParams={selectedTicket} />,
    })
  }

  return (
    <div className={s.container}>
      <p className={s.textPayment}>
        {`${t('purchase_page.agree')} `}
        <span
          className={s.underLine}
          onClick={showTicketTariff}
        >
          {t('purchase_page.tariff')}
        </span>
        {` ${t('purchase_page.and')} `}
        <span
          className={s.underLine}
          onClick={showPublicOffer}
        >
          {t('purchase_page.offers')}
        </span>
        {` ${t('purchase_page.end')}`}
      </p>
    </div>
  )
}
